export default __webpack_public_path__ + "img/manila_mixer-140a6a5568c855266e023e97211162e9.png";